import React from "react";
import { Header_panel } from "../Useful/Useful";
import { Button, Form } from "reactstrap";
import "../Useful/useful.css";
import { UploadFile } from "../../fetch";

export default class AddSetting extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
      key: "",
      title: "",
      desc: "",
      picUrl: "",
    };

    if (props.fillData.id) {
      this.state = props.fillData;
    }

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    // this.handleOnChange = this.handleOnChange.bind(this);
  }

  handleChange = (name) => (event) => {
    this.setState({ [name]: event.target.value });
  };

  handleSubmit(event) {
    event.preventDefault();
    this.props.onFormSubmit(this.state);
    this.setState({ id: "", key: "", title: "", desc: "", picUrl: "" });
  }

  handleSelectFile = (event) => {
    if (event.target.files.length <= 0) {
      this.setState({ picUrl: "" });
      return false;
    }
    UploadFile(event.target.files[0])
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        this.setState({ picUrl: response.pathFName });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  render() {
    return (
      <div className="col-lg-12 mypanel shadow">
        <Header_panel
          title="افزودن تنظیمات"
          idMenu="#navbarToggleExternalContentSettingAdd"
        />
        <div className="pos-f-t">
          <div className="collapse" id="navbarToggleExternalContentSettingAdd">
            <Form onSubmit={this.handleSubmit}>
              <div className="row p-4">
                <div className="col-lg-3">
                  <div className="form-group textg">
                    <label className="control-label" htmlFor="first_name">
                      * کلید{" "}
                    </label>
                    <input
                      // ref={this.fileInput}
                      value={this.state.key}
                      onChange={this.handleChange("key")}
                      className="contactInput form-control"
                      name="key"
                      placeholder="کلید..."
                    />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="form-group textg">
                    <label className="control-label" htmlFor="first_name">
                      * عنوان
                    </label>
                    <input
                      value={this.state.title}
                      onChange={this.handleChange("title")}
                      className="contactInput form-control"
                      name="title"
                      placeholder="عنوان..."
                    />
                  </div>
                </div>

                <div className="col-lg-12 ">
                  <div className="form-group textg ">
                    <label className="control-label" htmlFor="image">
                      انتخاب فایل
                    </label>
                    <div className="custom-file">
                      <input
                        type="file"
                        accept="image/*"
                        className="custom-file-input"
                        id="image"
                        aria-describedby="inputGroupFileAddon01"
                        onChange={this.handleSelectFile}
                      />
                      <div
                        className="custom-file-label "
                        value={this.state.picUrl}
                        htmlFor="inputGroupFile01"
                      >
                        <span className="pad">
                          {" "}
                          آدرس تصویر &larr; {this.state.picUrl}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                {this.state.picUrl && (
                  <div className="col  mb-5 ">
                    <div className=" m-2 mb-5 ">
                      <img
                        width={150}
                        height={150}
                        // value={item.url}
                        src={`https://macks-b.ir/${this.state.picUrl}`}
                        alt={""}
                      />
                    </div>
                  </div>
                )}

                {/* <div className="col-lg-2">
                  <div className="form-group ">
                    <label className="control-label" htmlFor="first_name">
                      انتخاب فایل
                    </label>
                    <div className="custom-file">
                      <input
                        type="file"
                        className="custom-file-input"
                        id="inputGroupFile01"
                        aria-describedby="inputGroupFileAddon01"
                        onChange={this.handleSelectFile}
                      />
                      <label
                        className="custom-file-label"
                        value={this.state.picUrl}
                        htmlFor="inputGroupFile01"
                      >
                        آدرس تصویر
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3">
                  <div className="form-group textg">
                    <label className="control-label" htmlFor="first_name">
                      آدرس فایل
                    </label>
                    <div style={{ fontsize: "10px" }}>{this.state.picUrl}</div>
                  </div>
                </div> */}
                <div className="col-lg-12">
                  <div className="form-group textg">
                    <label className="control-label" htmlFor="first_name">
                      توضیحات
                    </label>
                    <textarea
                      rows="2"
                      value={this.state.desc}
                      onChange={this.handleChange("desc")}
                      className="contactInput form-control"
                      name="title"
                      placeholder="متن..."
                    />
                  </div>
                </div>
              </div>
              <Button type="submit" color="primary" id="regProdbtn">
                ذخیره
              </Button>
            </Form>
          </div>
        </div>
      </div>
    );
  }
}
